import { RoleName } from "consts/auth";
import { Filters, OnboardingApplicationStatus } from "consts/onboarding";
import { RequestQueryMapper } from "util/request-query-mapper";

export const whereUserRole = (roleName: RoleName) => (query?: string) => (
    RequestQueryMapper.from(query)
        .containsIn(Filters.userRole, roleName)
        .toString()
);

export const disableCta = (status: OnboardingApplicationStatus) => [
    OnboardingApplicationStatus.NotStarted,
    OnboardingApplicationStatus.InProgress
].includes(status);
